import { HideFreespinsElements } from "commands/freespins";
import { ShowUIButtons } from "commands/ui-buttons";
import State from "slotworks/state-machine/states/state";
import { sequence, parallel } from "slotworks/utils/race-utils";
import GameState from "slotworks/model/game-state";
import regulation from "slotworks/integration/revolver/regulations/regulation";
import Contract from "slotworks/utils/contract";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import translations from "slotworks/i18n/translations";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import ShowPromoFSafterFreespins from "slotworks/commands/promo-free-spins/show-pfs-after-freespins";
import Layers from "slotworks/graphics/layers/layers";
import Components from "slotworks/components/components";
import { ResetToTriggeringSpinCommand } from "slotworks/commands/betbar/reset-to-triggering-spin";
import rainbowStacksComponents from "components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import RainbowStacksFreespinRecord from "integration/revolver/schema/freespin-record";
import { GetLastFreespinRecord } from "util/tools";
import RainbowStacksSpinRecord from "integration/revolver/schema/spin-record";
import gameState from "slotworks/model/game-state";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import soundManager from "slotworks/sound/sound-manager";

export default class RainbowStacksExitFreespins extends State {

    protected summaryScenes: string[] = ["freespinssummary", "freespins"];
    protected promptContents: Map<string, string>;

    private prompt: PromptContent;

    public onEnter() {
        this.prompt = null;
        this.promptContents = new Map<string, string>();
        sequence([
            () => this.setupPrompt(),
            () => Layers.CelebrationBackground.setScene("respins"),
            () => rainbowStacksComponents.prompt.showPrompt(this.prompt, null, this.showBaseElements),
            () => Layers.CelebrationBackground.defaultScene(),
            () => this.afterPrompt()
        ]).then(() => this.complete());
    }

    public complete() {
        soundManager.customEvent("base_music");
        Layers.SmartButton.show();
        Layers.BetBar.show();
        GameState.getCurrentGame().inFreespinsGame = false;
        regulation.updateNetPosition(GameState.getNetPosition());
        this.setWinnings();
        setTimeout(() => super.complete(), 500);
    }

    protected beforePrompt() {
        return Contract.empty();
    }

    protected setupPrompt() {
        return Contract.wrap(() => {
            smartButton.setFlag(SmartButtonFlag.PROMPT, true);
            Layers.SmartButton.hide();
            Layers.BetBar.hide();

            const freeSpinsWin = GameState.getCurrentGame().getRunningFreespinsWinTotal();
            
            const message = translations.get("fs.wsu", { VALUE: freeSpinsWin });
            const summaryScene = "freespinssummary";
            const record = GameState.getCurrentGame().getCurrentRecord();
            let freespinsRecord: RainbowStacksFreespinRecord;

            if(record instanceof RainbowStacksFreespinRecord) {
                freespinsRecord = record;
            } else {
                freespinsRecord = GetLastFreespinRecord();
            }
            const freespinsPlayed = freespinsRecord.totalFreespins.toString();

            this.prompt = new PromptContent([summaryScene, ...this.summaryScenes], 4000);
            this.prompt.addContinueButton("continue");

            this.promptContents.set("winMessage", message);
            this.promptContents.set("played", freespinsPlayed);
            this.prompt.addText(this.promptContents);

            this.prompt.countupText("value", freeSpinsWin, 2000);
        });
    }

    protected afterPrompt() {
        return parallel([
            () => Contract.wrap(() => {
                smartButton.setFlag(SmartButtonFlag.PROMPT, false);
                ShowPromoFSafterFreespins();
                ShowUIButtons();
            }),
            () => this.resetToTriggeringSpin(),
            () => StaticSymbolsCommand()
        ]);
    }

    protected resetToTriggeringSpin() {
        const record = gameState.getCurrentGame().resetRecordIndex() as RainbowStacksSpinRecord;
        if(record.grid) {
            for(let reel of record.grid) {
                for(let index in reel) {
                    reel[index].replace("fs", "");
                }
            }
        }
        return Contract.wrap(() => ResetToTriggeringSpinCommand());
    }

    protected setWinnings(): void {
        const totalWin = GameState.getCurrentGame().totalCreditsWon;
        Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);
    }

    protected showBaseElements = () => {
        setTimeout(() => HideFreespinsElements(), 400);
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/exit-freespins.ts